import Vue from "vue";
import Router from "vue-router";

import { checkAuth, checkRoute } from "@/libs/auth/isAuth";

const Main = () =>
  import(/* webpackChunkName 'Main' */ "@/components/Main/Main");
const Login = () =>
  import(/* webpackChunkName 'Login' */ "@/components/Login/Login");
const NotFound = () =>
  import(/* webpackChunkName 'NotFound' */ "@/components/NotFound/NotFound");

// Main
import dashboard from "@/router/sections/main/dashboard";
import profile from "@/router/sections/main/profile";
import salesReport from "@/router/sections/main/salesReport";
import statisticsReport from "@/router/sections/main/statisticsReport";
import statisticsReports from "@/router/sections/main/statisticsReports";
import users from "@/router/sections/main/users";
import usersGroups from "@/router/sections/main/usersGroups";
import generatedLeadReport from "@/router/sections/main/generatedLeadReport";


// Astrology
import astroEvents from "@/router/sections/astrology/astroEvents";
import biorhythm from "@/router/sections/astrology/biorhythm";
import birthChart from "@/router/sections/astrology/birthChart";
import cookies from "@/router/sections/astrology/cookies";
import compatibility from "@/router/sections/astrology/compatibility";
import сompatibilityScore from "@/router/sections/astrology/сompatibilityScore";
import famousBaby from "@/router/sections/astrology/famousBaby";
import futureBaby from "@/router/sections/astrology/futureBaby";
import horoscopes from "@/router/sections/astrology/horoscopes";
import meditation from "@/router/sections/astrology/meditation";
import moods from "@/router/sections/astrology/moods";
import moonSigns from "@/router/sections/astrology/moonSigns";
import numerology from "@/router/sections/astrology/numerology";
import anotherLife from "@/router/sections/astrology/anotherLife";
import palmLines from "@/router/sections/astrology/palmLines";
import signRelationship from "@/router/sections/astrology/signRelationship";
import tarot from "@/router/sections/astrology/tarot";
import yesOrNo from "@/router/sections/astrology/yesOrNo";
import appConfigs from "@/router/sections/astrology/app_configs";
import zodiacDescriptions from "@/router/sections/astrology/zodiacDescriptions";

// CloudFlare
import landingDomains from "@/router/sections/cloudflare/landingDomains";

// VPN
import accessLevels from "@/router/sections/vpn/accessLevels";
import appVersions from "@/router/sections/vpn/appVersionsFlags";
import blackListDevices from "@/router/sections/vpn/blackListDevices";
import campaigns from "@/router/sections/vpn/campaigns";
import cities from "@/router/sections/vpn/cities";
import clientApps from "@/router/sections/vpn/clientApps";
import countries from "@/router/sections/vpn/countries";
import dataCenter from "@/router/sections/vpn/dataCenters";
import landings from "@/router/sections/vpn/landings";
import masterServer from "@/router/sections/vpn/masterServer";
import rebills from "@/router/sections/vpn/rebills";
import receipts from "@/router/sections/vpn/receipts";
import statistics from "@/router/sections/vpn/statistics";
import tariffs from "@/router/sections/vpn/tariffs";
import tickets from "@/router/sections/vpn/tickets";
import trafficSources from "@/router/sections/vpn/trafficSources";
import vpns from "@/router/sections/vpn/vpns";
import mailSubject from "@/router/sections/vpn/mailSubject";
import mailSubjectCreate from "@/router/sections/vpn/mailSubjectCreate";
import mailSubjects from "@/router/sections/vpn/mailSubjects";
import partnerPromoCodes from "@/router/sections/vpn/partnerPromoCodes";
import partners from "@/router/sections/vpn/partners";
import premiumIssuance from '@/router/sections/vpn/premiumIssuance';

// Subscriptions

import subscriptionsCampaigns from "@/router/sections/subscriptions/campaigns";
import sbuscriptionsClientApps from "@/router/sections/subscriptions/clientApps";
import sbuscriptionsLandings from "@/router/sections/subscriptions/landings";
import sbuscriptionsStatistics from "@/router/sections/subscriptions/statistics";
import sbuscriptionsTariffs from "@/router/sections/subscriptions/tariffs";
import sbuscriptionsTrafficSources from "@/router/sections/subscriptions/trafficSources";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "open active",
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        label: "Home",
      },
      redirect: "dashboard",
      component: Main,
      beforeEnter: checkAuth,
      children: [
        // Main
        dashboard,
        profile,
        users,
        usersGroups,
        generatedLeadReport,
        salesReport,
        statisticsReport,
        statisticsReports,
        // Astrology
        astroEvents,
        biorhythm,
        birthChart,
        cookies,
        compatibility,
        сompatibilityScore,
        famousBaby,
        futureBaby,
        horoscopes,
        meditation,
        moods,
        moonSigns,
        numerology,
        anotherLife,
        palmLines,
        signRelationship,
        tarot,
        yesOrNo,
        appConfigs,
        zodiacDescriptions,

        // CloudFlare
        landingDomains,

        // VPN
        accessLevels,
        appVersions,
        blackListDevices,
        campaigns,
        cities,
        countries,
        dataCenter,
        landings,
        masterServer,
        rebills,
        receipts,
        statistics,
        tariffs,
        tickets,
        trafficSources,
        vpns,
        sbuscriptionsClientApps,
        subscriptionsCampaigns,
        sbuscriptionsLandings,
        sbuscriptionsTariffs,
        sbuscriptionsTrafficSources,
        sbuscriptionsStatistics,
        clientApps,
        mailSubjectCreate,
        mailSubject,
        mailSubjects,
        partnerPromoCodes,
        partners,
        premiumIssuance,
      ],
    },
    {
      path: "/auth",
      name: "login",
      component: Login,
      beforeEnter: checkRoute,
    },
    {
      path: "*",
      name: "404",
      component: NotFound,
    },
  ],
});

export default router;
